<template>
  <div class="card-devices">
      <v-card height="100%" min-width="125px" color="white" flat>
        <v-layout justify-left align-center wrap>
          <v-flex xs3>
            <v-icon color="grey" v-if="type == 'event'">events</v-icon>
            <v-icon color="grey" v-else-if="type == 'function'">functions</v-icon>
            <v-icon color="grey" v-else-if="type == 'form'">list_alt</v-icon>
            <v-icon color="grey" v-else-if="type == 'ticket'">confirmation_number</v-icon>
            <v-icon color="grey" v-else-if="type == 'model'">storage</v-icon>

          </v-flex>
          <v-flex xs9>
          <h4 class='grey--text font-weight-light'>{{name}}</h4>
          </v-flex>
          <!-- <v-flex xs3>
            <v-icon color="grey" @click="selectNode">info</v-icon> -->
            <!-- <v-icon color="grey" v-if="(data||description)&&!showDetail" @click="showDetail=true, updateConnectors()">expand_more</v-icon>
            <v-icon color="grey" v-else-if="data||description" @click="showDetail=false, updateConnectors()">expand_less</v-icon> -->
          <!-- </v-flex> -->
          
        </v-layout>
        <v-card-text v-if="showDetail" style="overflow-y: auto; max-height:400px">
          <v-layout justify-center align-center wrap>
            <v-flex xs12 v-if="description"><span class="grey--text">{{description}}</span></v-flex>
            <v-flex xs12>
               <vue-json-pretty
               :path="'res'"
      :data="data">
    </vue-json-pretty>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import event from '@/services/Event'
export default {
  components: {
    VueJsonPretty
  },
  props: ['name', 'type', 'description', 'data', 'functions', 'selectedFunction'],
  data(){
    return {
      id: null,
      selectedNode: null,
      showDetail: false,
      isSelected: false
    }
  },
  methods: {
    updateConnectors() {
      const id = this.$el.parentElement.parentElement.id;
      this.id = id
      event.$emit('updateConnector', id);
    },
    selectNode() {
      const id = this.$el.parentElement.parentElement.id;
      this.id = id
      event.$emit('selectNode', id);
    }
  }
}
</script>